module.exports = __webpack_public_path__ + "img/Aruba.336bb1cc.svg";